"use client";

import { tsv } from "@faire/slate/lib/tsv";
import React, { useState } from "react";

import { AvatarSize } from "./types";

interface IProps {
  /**
   * The border color of the avatar
   */
  borderColor?: string;

  /**
   * Container className
   */
  className?: string;

  /**
   * The image url of the avatar
   */
  imageUrl?: string;
  /**
   * The label of the avatar
   */
  label?: string;

  /**
   * The size of the avatar
   */
  size?: AvatarSize;
}

export const AvatarBase: React.FC<React.PropsWithChildren<IProps>> = ({
  label,
  size,
  imageUrl,
  borderColor,
  children,
  className,
}) => {
  const [imageError, setImageError] = useState(false);

  const containerCls = containerStyle.cls({ size, className });
  const containerVars = containerStyle.vars({
    borderColor,
    backgroundColor:
      imageUrl && !imageError
        ? "var(--fs-avatar-background-with-image)"
        : "var(--fs-avatar-background-without-image)",
  });

  return (
    <span className={containerCls} style={containerVars}>
      {imageUrl && !imageError ? (
        <img
          className="h-full w-full rounded-[inherit] object-cover"
          src={imageUrl}
          alt={label}
          onError={() => setImageError(true)}
        />
      ) : (
        <label>{label?.[0]?.toUpperCase()}</label>
      )}
      {children}
    </span>
  );
};

const containerStyle = tsv({
  vars: {
    borderColor: "fs-avatar-border-color",
    backgroundColor: "fs-avatar-background-color",
  },
  base: ["fs-avatar fs-avatar__placeholder"],
  variants: {
    size: {
      xxSmall: "font-fs-subheading-medium size-(--slate-dimensions-8)",
      xSmall: "font-fs-section-heading size-(--slate-dimensions-10)",
      small: "font-fs-section-heading size-(--slate-dimensions-12)",
      medium: "font-fs-section-heading size-(--slate-dimensions-14)",
      large: "font-fs-section-heading size-(--slate-dimensions-16)",
      xLarge: "font-fs-display-s-sans-semibold h-24 w-24",
    } satisfies Record<AvatarSize, string>,
  },
});
